import axios from 'axios'
import { BASE_URL } from '../constants/routes'
import { FPJS_SECRET_TOKEN, FPJS_VISITORS_ENDPOINT, IS_VERCEL, RANDOM_BOTD } from '../constants/env'
import { generateRandomString } from './common'
import type { VisitHistoryEvent } from '../types/visitHistory'

export async function fetchVisitEventByRequestId(requestId: string): Promise<VisitHistoryEvent> {
  if (IS_VERCEL) {
    const randomPath = generateRandomString(parseInt(RANDOM_BOTD, 10))
    const response = await axios.get<VisitHistoryEvent>(`${BASE_URL}/${randomPath}/`, {
      headers: {
        'x-vercel-function': 'event',
        'x-request-id': requestId,
      },
    })
    return response.data
  }

  const response = await axios.get<VisitHistoryEvent>(`${FPJS_VISITORS_ENDPOINT}/${encodeURIComponent(requestId)}`, {
    headers: {
      Authorization: `Bearer ${FPJS_SECRET_TOKEN}`,
    },
  })
  return response.data
}
